module.exports = __webpack_public_path__ + "static/media/Olivier_Tisseyre.e43de5b8.jpg";